import { render, staticRenderFns } from "./Delegator.vue?vue&type=template&id=7d8e707f"
import script from "./Delegator.vue?vue&type=script&lang=js"
export * from "./Delegator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports